import { CodeTemplates } from "../../../Constantes/codeDocumentationTemplates";
import { DocumentationRequestTypes, DocumentationRequestWithSubtypes, factoryProcessClaimsTemplateTypes, factoryProcessVehicleDeliveryTemplateTypes, SubstitutionVehicleTemplateTypes, TerminationsTemplateTypes } from "../../../Constantes/documentataionRequestTypes";
import { factoryActive } from "../../../Constantes/factoryActive";
import { FuelCardTypes } from "../../../Constantes/FuelCardTypes";
import { WorkshopAppointmentTypes } from "../../../Constantes/worskhopAppointmentTypes";
import { selectContract } from "../../../redux/contract/selectors";
import { openModal } from "../../../redux/modal/modalSlice";

//Email
  export function validateEmailForm(emailForm, dispatch){
    if(emailForm.addresses.length === 0){
      dispatch(openModal({type: "warning", message: "O campo destinatário é obrigatório"}));
      return false;
    }
    if(!emailForm.templateId){
      dispatch(openModal({type: "warning", message: "O campo template é obrigatório"}));
      return false;
    }
    if(emailForm.message.trim() === ""){
      dispatch(openModal({type: "warning", message: "O campo mensagem é obrigatório"}));
      return false;
    }
    return true
  }

//WorkshopAppointment

  export function validateWorkshopAppointmentData(data, dispatch){

  if(data.templateCode !== WorkshopAppointmentTypes.VIP_SERVICE){
    if(!validateCommonFieldsWorkshopAppointment(data, dispatch)){return false};
  }
  
    if(data.templateCode === WorkshopAppointmentTypes.FAILURE || data.templateCode === WorkshopAppointmentTypes.FAILURE_PLUS_TYRES )
    {
        if(!validateFailureFields(data,dispatch)){
          return false;
        };
    }
    
    if(data.templateCode === WorkshopAppointmentTypes.ITV)
    {
       if(!validateItvFields(data,dispatch)){
         return false
       }
    }
  
    if(data.templateCode === WorkshopAppointmentTypes.FAILURE_PLUS_TYRES || data.templateCode === WorkshopAppointmentTypes.TYRES || data.templateCode === WorkshopAppointmentTypes.MAINTENANCE_PLUS_TYRES || (data.templateCode === WorkshopAppointmentTypes.VIP_SERVICE && data.interventionType === "Neumáticos"))
    {    
      if(!validateTyresFields(data, dispatch)){
        return false
      }
    }

    if(data.templateCode === WorkshopAppointmentTypes.VIP_SERVICE)
    {
      if(!validateVipFields(data,dispatch)){
        return false
      }
    }
    if(data.templateCode === WorkshopAppointmentTypes.TYRES && data.isBMW &&(!data.acceptMM || data.acceptMM.trim() === ""))
    {
        dispatch(openModal({type: "warning", message: `El campo '¿Acepta MM?' es obligatorio`}))
        return false;
    }    
    return true  
  }

  export function validateCommonFieldsWorkshopAppointment(data, dispatch){
  
    let isValid = false;

    if(!data.postalCode || data.postalCode.trim() === "" || data.postalCode.length !== 5){
      dispatch(openModal({type: "warning", message: `Introduzca un código postal válido`}))
      return isValid
    };
    if(!data.province || data.province.trim() === ""){
      dispatch(openModal({type: "warning", message: `El campo Provincia es obligatorio`}))
      return isValid
    };
    if(data.templateCode !== WorkshopAppointmentTypes.ITV && (!data.kilometers || data.kilometers.toString().trim() === "")){
      dispatch(openModal({type: "warning", message: `El campo Kilometraje es obligatorio`}))
      return isValid
    };
    if(!data.name || data.name.trim() === ""){
      dispatch(openModal({type: "warning", message: `El campo Nombre es obligatorio`}))
      return isValid
  };
    if(!data.surname || data.surname.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Apellidos es obligatorio`}))
    return isValid
  };
    if(!data.option1){
      dispatch(openModal({type: "warning", message: `El campo Opción 1 es obligatorio`}))
      return isValid
  };


  if(!data.notes || data.notes.trim() === ""){
      let notesFieldName = "Notas";
      if (data.templateCode === WorkshopAppointmentTypes.FAILURE || data.templateCode === WorkshopAppointmentTypes.FAILURE_PLUS_TYRES)
      {
        notesFieldName = "Motivo Avería"
      } 
      if (data.templateCode === WorkshopAppointmentTypes.MAINTENANCE || data.templateCode === WorkshopAppointmentTypes.MAINTENANCE_PLUS_TYRES)
      {
        notesFieldName = "Motivo Mantenimiento"
      }
      if(data.templateCode === WorkshopAppointmentTypes.VIP_SERVICE)
      {
        notesFieldName = "Descrição del interés"
      }

      dispatch(openModal({type: "warning", message: `El campo ${notesFieldName} es obligatorio`}))
      return isValid
  };
  
  isValid = true;
  
  return isValid
  }

  export function validateFailureFields(data, dispatch){
    let isValid = false
    if(data.orangeLightPilot === null){
      dispatch(openModal({type: "warning", message: `El campo Piloto Naranja es obligatorio`}))
      return isValid
    }
  
    isValid = true;
  
    return isValid
  }
  
  export function validateItvFields(data, dispatch){
    let isValid = false;
  
    if(data.itvBonus === null){
      dispatch(openModal({type: "warning", message: "El campo Bono ITV es obligatorio"}));
      return isValid;
    }
  
    if(data.originalDocItv === null){
      dispatch(openModal({type: "warning", message: "El campo Doc. Original ITV es obligatorio"}));
      return isValid;
    }
  
    if(!data.stationId){
      dispatch(openModal({type: "warning", message: "El campo Estación es obligatorio"}));
      return isValid;
    }
    if(!data.fuelType){
      dispatch(openModal({type: "warning", message: "El campo Combustible es obligatorio"}));
      return isValid;
    }
  
    isValid = true;
    return isValid
  
  }
  
 export function validateTyresFields(data, dispatch){
    if(!data.tyreSize || data.tyreSize.trim() === "")
    {
      dispatch(openModal({type: "warning", message: "El campo Medida Neumáticos es obligatorio"}))
      return false
    }
    if(data.numberOfTyres === 2 && !data.tyrePosition){
      dispatch(openModal({type: "warning", message: "Seleccione el eje de los neumáticos"}))
      return false
    }
    return true
  
  }
  
export function validateVipFields(data, dispatch){

    if(!data.name || data.name.trim() === ""){
      dispatch(openModal({type: "warning", message: `El campo Nombre es obligatorio`}))
     return false
    };
    if(!data.surname || data.surname.trim() === ""){
      dispatch(openModal({type: "warning", message: `El campo Apellidos es obligatorio`}))
    return false
    };
    if(!data.address || data.address.trim() === ""){
      dispatch(openModal({type: "warning", message: `El campo Dirección de recogida es obligatorio`}))
    return false
    };
    if(!data.vipDate){
      dispatch(openModal({type: "warning", message: `El campo Fecha y Hora es obligatorio`}))
      return false
    };
    if(!data.interventionType || data.interventionType.toString().trim() === ""){
      dispatch(openModal({type: "warning", message: `El campo Tipo de intervención es obligatorio`}))
      return false
    }
    if((data.interventionType === "Revisión") && (!data.kilometers || data.kilometers.toString().trim() === "")){
      dispatch(openModal({type: "warning", message: `El campo Kilómetros actuales es obligatorio`}))
      return false
    };
    if((data.interventionType === "Avería" || data.interventionType === "Revisión") && !data.vehicleControl){
      dispatch(openModal({type: "warning", message: `El campo Testigo es obligatorio`}))
      return false
    };
    if(!data.notes || data.notes.toString().trim() === ""){
      dispatch(openModal({type: "warning", message: `El campo Descrição del interés es obligatorio`}))
      return false
    };
    return true
}

//FactoryProcess
  export function validateFactoryProcessData(dataForm, dispatch){
    const { additionalInfo: data } = dataForm;
    if(!data.templateCode){
      dispatch(openModal({type: "warning", message: "Debe seleccionar una tipología"}))
    //   setDisabledButtom({documentation: false, sms: false})
      return;
    }
  
    if(!validateCommonFieldsDocumentation(data)){return false};
  
    if(!data.email || data.email.trim() === ""){
      dispatch(openModal({type: "warning", message: `El campo Correo electrónico es obligatorio`}))
      return false
    };
    
    if(!data.phoneNumber || data.phoneNumber.trim() === ""){
      dispatch(openModal({type: "warning", message: `El campo Móvil es obligatorio`}))
      return false
    };
  
    if(Object.entries(factoryProcessClaimsTemplateTypes).some(x => x[1] === data.templateCode)){
      if(!data.workshopEntry){
        dispatch(openModal({type: "warning", message: `El campo Entrada taller es obligatorio`}))
        return false
      };
    }
    
    if(Object.entries(factoryProcessVehicleDeliveryTemplateTypes).some(x => x[1] === data.templateCode)){
      //validaciones plantillas del tipo de entrega vehículo
    }
  
    return true;
  }
  
//Documentation
  export function validateDocumentationData(data, dispatch){

  if(data.templateCode === DocumentationRequestTypes.ITV_BOND && data.queryOnly === true){
    return true
  }

  if(!validateCommonFieldsDocumentation(data, dispatch)){return false};

    if(data.templateCode  === DocumentationRequestTypes.FACTORY_PROCESS_DRIVER_CHANGE || data.templateCode  === DocumentationRequestTypes.INSURANCE_OTHER  || data.templateCode  === DocumentationRequestTypes.ORIGINAL_DUPLICATE || data.templateCode  === DocumentationRequestTypes.ORIGINAL || data.templateCode  === DocumentationRequestTypes.ZERO_EMISION_CERTIFICATE || data.templateCode  === DocumentationRequestTypes.RESIDENT_CARD ){
      if(!data.dni || data.dni.trim() === ""){
        dispatch(openModal({type: "warning", message: `El campo DNI es obligatorio`}))
        return false
      };
    }

    const templateHasSubtypes = DocumentationRequestWithSubtypes.some(documentationRequestType=> data.templateCode === documentationRequestType);

   if(templateHasSubtypes){
      if(!data.subtype){
        dispatch(openModal({type: "warning", message: "Debe seleccionar un Diferenciador"}))
        return false;
      }
   } 

    if(data.templateCode  !== DocumentationRequestTypes.RESIDENT_CARD ){
    
      if(!data.phoneNumber || data.phoneNumber.trim() === ""){ 
        dispatch(openModal({type: "warning", message: `El campo Móvil es obligatorio`}))
        return false
      };
    }
    if(data.templateCode  === DocumentationRequestTypes.INSURANCE_OTHER || data.templateCode !== DocumentationRequestTypes.ENVIRONMENTAL_STICKER && data.templateCode  !== DocumentationRequestTypes.PRODUCER_BOOK){
      if(!data.email || data.email.trim() === ""){
        dispatch(openModal({type: "warning", message: `El campo Correo electrónico es obligatorio`}))
        return false
      };
    }
    if(data.templateCode === DocumentationRequestTypes.ORIGINAL || data.templateCode === DocumentationRequestTypes.ORIGINAL_DUPLICATE ||data.templateCode === DocumentationRequestTypes.ENVIRONMENTAL_STICKER || data.templateCode === DocumentationRequestTypes.PRODUCER_BOOK || data.templateCode === DocumentationRequestTypes.RESIDENT_CARD || data.templateCode === DocumentationRequestTypes.EUROPEAN_PART){
      if(!data.address || data.address.trim() === ""){
        dispatch(openModal({type: "warning", message: `El campo Dirección es obligatorio`}))
        return false
      };
    }
    if(data.templateCode === DocumentationRequestTypes.ORIGINAL ){
      if(!data.originalVhDocType || data.originalVhDocType.trim() === "" && data.subtype == "original_mtr"){
        dispatch(openModal({type: "warning", message: `El campo Tipo es obligatorio`}))
        return false
      };
    }
    if(data.templateCode === DocumentationRequestTypes.ORIGINAL_DUPLICATE && !data.inform){
        dispatch(openModal({type: "warning", message: `El campo Informado costes es obligatorio`}))
        return false
      };
    if(data.templateCode === DocumentationRequestTypes.ITV_BOND){
      if(!data.province || data.province.trim() === ""){
        dispatch(openModal({type: "warning", message: `El campo Provincia es obligatorio`}))
        return false
      };
      if(!data.aaff){
        dispatch(openModal({type: "warning", message: "El campo Decisión es obligatorio"}));
        return false;
      }
      if(factoryActive && !data.itvType){
        dispatch(openModal({type: "warning", message: "El campo ITV es obligatorio"}));
        return false;
      }
      if(!data.stationId){
        dispatch(openModal({type: "warning", message: "El campo Estación es obligatorio"}));
        return false;
      }
    }
    if(data.templateCode  === DocumentationRequestTypes.RESIDENT_CARD){
      if(!data.zone){
        dispatch(openModal({type: "warning", message: "El campo Zona es obligatorio"}));
        return false;
      }
    }
    if(data.templateCode  === DocumentationRequestTypes.ENVIRONMENTAL_STICKER){
      if(!data.reason || data.reason.trim() === ""){
        dispatch(openModal({type: "warning", message: "El campo Motivo es obligatorio"}));
        return false;
      }
      if(!data.costExcempt || data.costExcempt.trim() === ""){
        dispatch(openModal({type: "warning", message: "El campo Informado de costes es obligatorio"}));
        return false;
      }
    }
    return true;
  }
  
  export function validateCommonFieldsDocumentation(data, dispatch){
  
    if(!data.name || data.name.trim() === ""){
      dispatch(openModal({type: "warning", message: `El campo Nombre es obligatorio`}))
      return false;
    };
      if(!data.surname || data.surname.trim() === ""){
      dispatch(openModal({type: "warning", message: `El campo Apellidos es obligatorio`}))
      return false;
    };
      if(!data.notes || data.notes.trim() === ""){
        dispatch(openModal({type: "warning", message: `El campo Notas es obligatorio`}))
        return false;
    };
    return true;
  }

  export function validateInformationFields(data, dispatch){
  
    if(!obligatoryField(data.name, "Nome", dispatch) ||
    !obligatoryField(data.surname, "Apellidos", dispatch) ||
    !obligatoryField(data.email, "Correo electrónico", dispatch) ||
    !obligatoryField(data.phoneNumber, "Móvil", dispatch) ||
    !obligatoryField(data.notes, "Notas", dispatch) 
    ){
      return false
    }

    return true;
  }

  
  export function validateTerminationsData(data, dispatch, templateCode, contract){
    if(data.templateCode  === TerminationsTemplateTypes.RENTING_OTHER_INSURANCE || data.templateCode  === TerminationsTemplateTypes.RENTING_OWN_INSURANCE || data.templateCode === TerminationsTemplateTypes.AAPP){

      if(!data.postalCode || data.postalCode.trim() === "" || data.postalCode.length !== 5){
        dispatch(openModal({type: "warning", message: `Introduzca un código postal válido`}))
        return false
      };
      if(!data.province || data.province.trim() === ""){
        dispatch(openModal({type: "warning", message: `El campo Provincia es obligatorio`}))
        return false
      };
      if(!data.city || data.city.trim() === ""){
        dispatch(openModal({type: "warning", message: `El campo Localidad es obligatorio`}))
        return false
      };
      if(data?.mtr && data.templateCode === TerminationsTemplateTypes.RENTING_OWN_INSURANCE){
        if(!data.address || data.address.trim() === ""){
          dispatch(openModal({type: "warning", message: `El campo Calle es obligatorio`}))
          return false
        };
        if(!data.streetNumber || data.streetNumber.trim() === ""){
          dispatch(openModal({type: "warning", message: `El campo Número es obligatorio`}))
          return false
        };
        if(data.streetNumber && data.streetNumber.length > 10){
          dispatch(openModal({type: "warning", message: `El campo Número es demasiado largo`}))
          return false
        };
      }else{
        if(!data.address || data.address.trim() === ""){
          dispatch(openModal({type: "warning", message: `El campo Dirección es obligatorio`}))
          return false
        };
      }
      if(!validateCommonFieldsDocumentation(data, dispatch)){return false};
  
      if(!data.mtr){
        if(!data.email || data.email.trim() === ""){
          dispatch(openModal({type: "warning", message: `El campo Correo electrónico es obligatorio`}))
          return false
        };
      }

    }

    if(data.phoneNumber && data.phoneNumber.trim().length < 9){
      dispatch(openModal({type: "warning", message: `El campo Móvil debe contener 9 dígitos`}))
      return false
    };

    if(!data.mtr && (data.templateCode !== TerminationsTemplateTypes.VALUATION && data.templateCode !== TerminationsTemplateTypes.TRADITIONAL_RENTING  && data.templateCode !== TerminationsTemplateTypes.AAPP)){
      if(data.pickDate == null || data.pickDate == ""){
        dispatch(openModal({type: "warning", message: `El campo Fecha recogida es obligatorio`}))
        return false
      };
    }
    if(data.templateCode === TerminationsTemplateTypes.VALUATION && (data.km == null || data.km == "")){
        dispatch(openModal({type: "warning", message: `El campo Km es obligatorio`}))
        return false
      };
    if(data.templateCode  === TerminationsTemplateTypes.RENTING_OWN_INSURANCE && data.mtr){
      if(!data.mtrType || data.mtrType.trim() === ""){
        dispatch(openModal({type: "warning", message: `El campo Tipo es obligatorio`}))
        return false
      };
      if(data.mtrType.toLowerCase().includes("pre") && data.pickDate == null || data.pickDate == ""){
        dispatch(openModal({type: "warning", message: `El campo Fecha recogida es obligatorio`}))
        return false
      };
      if(!data.mtrType.toLowerCase().includes("pre") && data.stopDate == null || data.stopDate == ""){
        dispatch(openModal({type: "warning", message: `El campo Fecha Parada Fact. es obligatorio`}))
        return false
      };
      if(data.mtrType.toLowerCase().includes("pre") && data.returnPlate && data.returnPlate.trim().toLowerCase().replace("-","") !== contract?.plate.trim().toLowerCase().replace("-","")){
        dispatch(openModal({type: "warning", message: `La matrícula a devolver no puede ser distinta a la del caso`}))
        return false
      }
    }

    return true;
  }

  export function validateSubstitutionData(data, dispatch, templateCode, contract){

   if(data.templateCode  !== SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_OTHER){
    if(factoryActive){
      if(!data.province || data.province.trim() === ""){
        dispatch(openModal({type: "warning", message: `El campo Provincia es obligatorio`}))
        return false
      };
      if(!data.city || data.city.trim() === ""){
        dispatch(openModal({type: "warning", message: `El campo Localidad es obligatorio`}))
        return false
      };
    }  
    } 

    if(data.templateCode === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_RETURN){
      if(!data.postalCode || data.postalCode.trim() === "" || data.postalCode.length !== 5){
        dispatch(openModal({type: "warning", message: `Introduzca un código postal válido`}))
        return false
      };
      if(!data.address || data.address.trim() === ""){
        dispatch(openModal({type: "warning", message: `El campo Calle es obligatorio`}))
        return false
      };
      if(!data.streetNumber || data.streetNumber.trim() === ""){
        dispatch(openModal({type: "warning", message: `El campo Número es obligatorio`}))
        return false
      };
      if(data.streetNumber && data.streetNumber.length > 10){
        dispatch(openModal({type: "warning", message: `El campo Número es demasiado largo`}))
        return false
      };
      if(data?.returnPlate && data?.returnPlate.trim().toLowerCase().replace("-","") === contract?.plate.trim().toLowerCase().replace("-","")){
        dispatch(openModal({type: "warning", message: `La matrícula a devolver debe ser distinta a la del caso`}))
        return false
      };
    }
    if(!data.name || data.name.trim() === ""){
      dispatch(openModal({type: "warning", message: `El campo Nombre es obligatorio`}))
      return false;
    };
      if(!data.surname || data.surname.trim() === ""){
      dispatch(openModal({type: "warning", message: `El campo Apellidos es obligatorio`}))
      return false;
    };
    if(!data.phoneNumber || data.phoneNumber.trim() === ""){
      dispatch(openModal({type: "warning", message: `El campo Móvil es obligatorio`}))
      return false
    };
    if(data.phoneNumber.trim().length < 9){
      dispatch(openModal({type: "warning", message: `El campo Móvil debe contener 9 dígitos`}))
      return false
    };

    if(data.templateCode  === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE){
      if((!data.email || data.email.trim() === "") || (data.email && !data.email.includes("@"))){
        dispatch(openModal({type: "warning", message: `El campo Correo electrónico es obligatorio y debe tener un formato correcto`}))
        return false
      };
      if((!data.dni || data.dni.trim() === "") || (data.dni && data.dni.trim().length != 9)){
        dispatch(openModal({type: "warning", message: `El campo DNI es obligatorio y debe tener un formato correcto`}))
        return false
      };
      if(factoryActive){
        if(!data.office || data.office.trim() === ""){
          dispatch(openModal({type: "warning", message: `El campo Oficina es obligatorio`}))
          return false
        };    
        if(!data.rentType || data.rentType.trim() === ""){
          dispatch(openModal({type: "warning", message: `El campo Modalidad alquiler es obligatorio`}))
          return false
        };      
        if(!data.category || data.category.trim() === ""){
          dispatch(openModal({type: "warning", message: `El campo Categoría es obligatorio`}))
          return false
        };    
      }
      if(!data.rentType.toLowerCase().includes("pool") &&!data.rentType.toLowerCase().includes("bolsa") &&!data.rentType.toLowerCase().replace('í','i').includes("dias") &&!data.rentType.toLowerCase().replace('í','i').includes("cortesia") &&!data.rentType.toLowerCase().includes("bankia") &&!data.rentType.toLowerCase().includes("ilimitado") && !data.rentType.toLowerCase().includes("diferencia") ){
        if(data.mtr === null || data.mtr === undefined){
          dispatch(openModal({type: "warning", message: `El campo MTR es obligatorio`}))
          return false
        };
      }
       if(!data.rentType.toLowerCase().includes("pool") &&!data.rentType.toLowerCase().includes("bolsa") &&!data.rentType.toLowerCase().replace('í','i').includes("dias") && !data.rentType.toLowerCase().includes("corto")){
        if(!data.workshop){
          dispatch(openModal({type: "warning", message: `El campo Nombre taller es obligatorio`}))
          return false
        };
      }
      if(!data.duration || data.duration.trim() === ""){
        dispatch(openModal({type: "warning", message: `El campo Duración es obligatorio`}))
        return false
      };
      if(!data.date || data.date.trim() === ""){
        dispatch(openModal({type: "warning", message: `El campo Fecha y hora es obligatorio`}))
        return false
      };

      if(data.reasignation){
        if(data.plateIn.trim().toLowerCase().replace("-","") !== contract?.plate.trim().toLowerCase().replace("-","")){
          dispatch(openModal({type: "warning", message: `La matrícula entrante no puede ser distinta a la del caso`}))
          return false
        }
      };
    }

    if(!data.notes || data.notes.trim() === ""){
      dispatch(openModal({type: "warning", message: `El campo Notas es obligatorio`}))
      return false;
    }
    return true;
  }

//Claims
export function validateClaimsData(data, dispatch){
    if(!data.templateCode){
      dispatch(openModal({type: "warning", message: "Debe seleccionar una tipología"}))
      return false;
    }

    if(!validateCommonFieldsDocumentation(data, dispatch)){return false};
  
    if(!data.email || data.email.trim() === ""){
      dispatch(openModal({type: "warning", message: `El campo Correo electrónico es obligatorio`}))
      return false
    };
    
    if(!data.phoneNumber || data.phoneNumber.trim() === ""){
      dispatch(openModal({type: "warning", message: `El campo Móvil es obligatorio`}))
      return false
    };
  
    if(Object.entries(factoryProcessClaimsTemplateTypes).some(x => x[1] === data.templateCode)){
      if(!data.workshopEntry){
        dispatch(openModal({type: "warning", message: `El campo Entrada taller es obligatorio`}))
        return false
      };
    }
    
    if(Object.entries(factoryProcessVehicleDeliveryTemplateTypes).some(x => x[1] === data.templateCode)){
      //validaciones plantillas del tipo de entrega vehículo
    }
  
    return true;
  }

//Delivery
export function validateDeliveryData(data, dispatch){

  if(!validateCommonFieldsDocumentation(data, dispatch)){return false}; 

  if(!data.email || data.email.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Correo electrónico es obligatorio`}))
    return false
  };
  
  if(!data.phoneNumber || data.phoneNumber.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Móvil es obligatorio`}))
    return false
  };

  if(data.templateCode === factoryProcessVehicleDeliveryTemplateTypes.FACTORY_PROCESS_TERM){

    if((!data.requestNumber || data.requestNumber.trim() === "") && (!data.contractNumber || data.contractNumber.trim() === "")){
      dispatch(openModal({type: "warning", message: `Debe cubrir uno de los siguientes campos: Nº Pedido, Nº Contrato`}))
      return false
    };
  }

  return true;

}

//OVC
export function validateOvcFormData(data, dispatch){

  if(!data.date){
    dispatch(openModal({type: "warning", message: `El campo Fecha y hora es obligatorio`}))
    return false;
  };

  if(!data.name || data.name.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Nombre es obligatorio`}))
    return false;
  };
    if(!data.surname || data.surname.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Apellidos es obligatorio`}))
    return false;
  };

  if(!data.dni || data.name.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo DNI/CIF es obligatorio`}))
    return false;
  };
  
  if(!data.phoneNumber || data.surname.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Móvil es obligatorio`}))
    return false;
  };

  if(!data.phoneNumber || data.surname.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Email es obligatorio`}))
    return false;
  };

  if(!data.company || data.company.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Empresa es obligatorio`}))
    return false;
  }

  if(!data.notes || data.notes.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Motivo es obligatorio`}))
    return false;
  }
  return true
} 

//ITV
export function validateFailedItvFormData(data, dispatch){

  if(!data.name || data.name.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Nombre es obligatorio`}))
    return false;
  };
    if(!data.surname || data.surname.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Apellidos es obligatorio`}))
    return false;
  };

  if(!data.phoneNumber || data.phoneNumber.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Móvil es obligatorio`}))
    return false;
  };

  if(!data.email || data.email.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Email es obligatorio`}))
    return false;
  };
  if(!data.accesoryInstaller){
    dispatch(openModal({type: "warning", message: `El campo Accesorio Instalado es obligatorio`}))
    return false;
  }
  if(!data.notes || data.notes.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Motivo ITV desfavorable es obligatorio`}))
    return false;
  }
  return true
} 


//Fuel card
export function validateFuelCardFormData(data, dispatch){

  if(!data.name || data.name.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Nombre es obligatorio`}))
    return false;
  };
    if(!data.surname || data.surname.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Apellidos es obligatorio`}))
    return false;
  };

  if(!data.phoneNumber || data.phoneNumber.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Móvil es obligatorio`}))
    return false;
  };

  if(!data.dni || data.dni.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo DNI es obligatorio`}))
    return false;
  };

  if(!data.email || data.email.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Email es obligatorio`}))
    return false;
  };

  if(data.templateCode === FuelCardTypes.DUPLICATE &&(!data.address || data.address.trim() === "")){
    dispatch(openModal({type: "warning", message: `El campo Dirección es obligatorio`}))
  return false
  };

  if(!data.notes || data.notes.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Notas es obligatorio`}))
    return false;
  }
  return true
}

//Marsh
export function validateMarshFormData(data, dispatch){

  if(!data.name || data.name.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Nombre es obligatorio`}))
    return false;
  };
  if(!data.surname || data.surname.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Apellidos es obligatorio`}))
    return false;
  };
  if(!data.phoneNumber || data.phoneNumber.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Móvil es obligatorio`}))
    return false;
  };
  if(!data.email || data.email.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Email es obligatorio`}))
    return false;
  };
  return true
}


function obligatoryField(field, fieldname, dispatch){
  if(!field || field.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo ${fieldname} es obligatorio`}))
    return false;
  } else {
    return true
  }
}


function validateBackOfficeFields(data, dispatch){
  if(data.templateCode === CodeTemplates.FIRST_DRIVER || data.templateCode=== CodeTemplates.SECOND_DRIVER || data.templateCode === CodeTemplates.TRAVEL_ABROAD ){
    if( !obligatoryField(data.client, "Cliente",dispatch ) ||
        !obligatoryField(data.postalCode, "Código Postal",dispatch ) ||
        !obligatoryField(data.province, "Provincia",dispatch ) ||
        !obligatoryField(data.address, "Dirección", dispatch) ||
        !obligatoryField(data.city, "Localidad", dispatch)){
          return false
        } else {
          return true
        }
  }
  if(data.templateCode === CodeTemplates.RENT ){
    if( !obligatoryField(data.client, "Cliente") ||
        !obligatoryField(data.cif, "CIF")){
          return false
        } else {
          return true
        }
  }
}

//Letters
export function validateLetterFormData(data, dispatch){
if(data.templateCode === CodeTemplates.FIRST_DRIVER){
  if(!obligatoryField(data.driverName, "Nome conductor habitual", dispatch) ||
     !obligatoryField(data.driverId, "DNI conductor habitual", dispatch)
  ){
    return false;
  };
}

if(data.templateCode === CodeTemplates.SECOND_DRIVER){
  if(!obligatoryField(data.driverName, "Nome segundo conductor", dispatch) || !obligatoryField(data.driverName, "Apellidos segundo conductor", dispatch) ||
     !obligatoryField(data.driverId, "DNI segundo conductor", dispatch)
  ){
    return false;
  };
}

if(data.templateCode === CodeTemplates.TRAVEL_ABROAD){
  if(!obligatoryField(data.driverName, "Nome del autorizado", dispatch) ||
     !obligatoryField(data.driverId, "DNI del autorizado", dispatch) ||
     !obligatoryField(data.authorizedCountries, "País a autorizar", dispatch) ||
     !obligatoryField(data.closeDate, "Fecha de fin", dispatch) 
  ){
    return false;
  };
}

if (!obligatoryField(data.email, "Email", dispatch)){
    return false
  }

  if(data.mtr){
      if(!validateBackOfficeFields){
        return false
      }
  }

  return true

}



//Other

export function validateOtherFormData(data, dispatch){
  if(!data.notes || data.notes.trim() === ""){
    dispatch(openModal({type: "warning", message: `El campo Notas es obligatorio`}))
    return false;
  }
  return true
} 
  
//AddFactoryComment

export function validateAddFactoryCommentData(data, dispatch){
  if(!data.comment || data?.comment.trim() === ""){
    dispatch(openModal({type: "warning", message: "El campo Comentario Fábrica es obligatorio"}))
    return false
  }
  if(!data.processId || data?.processId.trim() === ""){
    dispatch(openModal({type: "warning", message: "El caso debe tener un Número de Caso en Fábrica"}))
    return false
  }
  return true
}

//AdvanceFactoryCase

export function validateAdvanceFactoryCaseData(data, dispatch){

  if(data.isConditional && !data.conditionValue){
    dispatch(openModal({type: "warning", message: "El campo Decisión es obligatorio"}))
    return false
  }
  if(!data.comment || data?.comment.trim() === ""){
    dispatch(openModal({type: "warning", message: "El campo Comentario Fábrica es obligatorio"}))
    return false
  }
  if(!data.processId || data?.processId.trim() === ""){
    dispatch(openModal({type: "warning", message: "El caso debe tener un Número de Caso en Fábrica"}))
    return false
  }
  return true
}


//Validacion de los borradores (subtipos)

export function validateDocumentationDraft(data, dispatch){
  if(data.templateCode === DocumentationRequestTypes.ITV_BOND && data.queryOnly !== true){
      if (!obligatoryField(data.aaff, "Decisión", dispatch))
          return false;
  }
  if(DocumentationRequestWithSubtypes.some(template => template === data.templateCode))
  {
     if (!obligatoryField(data.subtype, "Diferenciador", dispatch))
          return false
  }
  return true;
}

export function validateSubstitutioVehicleDraft(data, dispatch){
  if(data.templateCode === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE){
    if(data.mtr === null || data.mtr === undefined){
      dispatch(openModal({type: "warning", message: "El campo Mtr es obligatorio"}))
      return false
    }
  }
  return true;
}